import { render } from "./SurveyPricesForm.vue?vue&type=template&id=30a34388"
import script from "./SurveyPricesForm.vue?vue&type=script&lang=js"
export * from "./SurveyPricesForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__